import { AllTokens } from "gql/graphql";
import { ReactNode } from "react";
import { Guard } from "@/shared/security/model/guard/guard";

/** Раздел динамических атрибутов: редактор атрибутов, их список и справочники. */
export function RestrictDynamicAttributes({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.AdminCompanyDynamicAttributes]}
    >
      {children}
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}
